import axios from "axios";
export const saveCompanyInfo = async (values) => {

    var result = { Status: true, Message: "", Data: null };
    let logoImage = [values.logo.indexOf("static/") === -1 ? values.logo.split('base64,')[1] : values.logo];
    console.log("values", values);
    var data = {
        CompanyName: values.companyName,
        CompanyId: values.companyId,
        PhoneNb: values.phoneNb,
        Address: values.address,
        Logo: logoImage.join(';'),
        SaleStatus: values.saleStatus,
        NotiMessage: values.notiMessage,
        ContactPerson: values.contactPerson,
        ContactPhoneNb: values.contactPhoneNb,
        UpdatedBy: values.updatedBy,
        LogoToDelete: values.logoToDelete,
        TimeZoneId: values.selectedTimeZoneId.value,
        TopupStartTime:values.startTime,
        TopupEndTime:values.endTime,
    }


    try {
        const response = await axios.put(`/api/CompanyInfo/${data.CompanyId}`, data)
        if (response && response.status === 200) {
            return response.data;
        } else {
            result.Status = false;
            result.Message = "Something went wrong";
            return result;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        } else {
            result.Status = false;
            result.Message = "Unhandled exception";
            return result;
        }
    }
}


export const GetCompanyInfoById = async (id) => {
    // console.log("id" , id);
    var data = {
        CompanyId: parseInt(id),
    }
    try {
        const response = await axios.post(`/api/CompanyInfo/GetCompanyInfoById`, data);

        if (response && response.status === 200) {
            return response.data;
        } else {
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        } else {
            let exceptionData = { expmessage: error.response.data.title, expstring: true }
            return exceptionData;
        }
    }
}

export const GetTimeZones = async () => {
    const response = await axios.get(`/api/CompanyInfo/GetTimeZones`);

    try {
        if (response && response.status === 200) {
            return response.data;
        } else {
            return {
                status: false,
                message: response.message,
                data: null
            }
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        } else {
            let exceptionData = { expmessage: error.response.data.title, expstring: true }
            return exceptionData;
        }
    }
}

export const GetCompanyList = async (currentPage,rowPerPage) => {
    const data = {
        CurrentPage: currentPage,
        RowPerPage: rowPerPage
    }
    try {
        const response = await axios.post(`/api/CompanyInfo/GetCompanyList`,data);

        if (response && response.status === 200) {
            return response.data;
        } else {
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        } else {
            let exceptionData = { expmessage: error.response.data.title, expstring: true }
            return exceptionData;
        }
    }
}

export const deleteCompany = async (values) => {
    try {
        var data = {
            CompanyId: values.companyId,
        }
        const response = await axios.post(`/api/CompanyInfo/Delete`, data);
        console.log('response', response);
        if (response && response.status === 200) {
            return response.data;
        } else {
            response.status = false;
            response.Message = "Something went wrong";
            return response;
        }
    } catch (error) {
        console.log(error)
    }
}
